//@ts-nocheck

'use client'

import React, { useState, useEffect } from 'react'
import * as S from './Header.styles'

import Link from 'next/link'

// import { useModal } from '@contexts/Modal'
import useMediaQuery from '../../../hooks/useMediaQuery'
import SectionThemeProvider from '../../../contexts/SectionTheme.context'

import { Visible } from '../../atoms/GridSystem'
import { ButtonLabel } from '../../atoms/Typography/Typography.component'
import Button from '../../atoms/Button/Button.component'
import Icon from '../../atoms/Icon/Icon.component'
import LanguageSwitch from '../../molecules/LanguageSwitch/LanguageSwitch.component'

import Menu from '../Menu/Menu.component'
import MenuMobile from '../Menu/MenuMobile/MenuMobile.component'

import useScrollDirection from '../../../hooks/useScrollDirection'

import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'

type HeaderMenu = {
  label: string
  href: string
  cta?: {
    label: string
    href: string
  }
  iconStart?: string
}

type HeaderProps = {
  serviceMenu?: HeaderMenu[]
  headerMenu?: HeaderMenu[]
  menu: HeaderMenu[]
}

const Header = ({
  serviceMenu,
  headerMenu,
  menu,
  pageLocalizations,
}: HeaderProps) => {
  const t = useTranslations('header')
  const [isOpenMenu, setIsOpenMenu] = useState(false)
  const [submenu, setSubmenu] = useState(false)
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)
  const scrollDirection = useScrollDirection()
  let router

  try {
    router = useRouter()
  } catch (err) {
    console.log(err)
  }

  // const { showModal, closeModal } = useModal()
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const allSiteLink = serviceMenu?.find(({ isAllSiteLink }) => isAllSiteLink)

  const handleToggleMenu = (passedSubmenu: string) => {
    if (isMobile) {
      isOpenMenu ? handleCloseMenu() : handleOpenMenu()
    } else {
      if (isOpenMenu && submenu === passedSubmenu) {
        handleCloseMenu()
      } else {
        handleOpenMenu(passedSubmenu)
      }
    }
  }

  const handleCloseMenu = () => {
    setIsOpenMenu(false)
    setSubmenu(false)
    if (isMobile) setIsSubmenuOpen(false)
    document.body.style.overflow = null
  }

  const handleOpenMenu = (submenu: string) => {
    setIsOpenMenu(true)
    if (submenu) setSubmenu(submenu)
    document.body.style.overflow = 'hidden'
  }

  const toId = (s: string) =>
    `submenu-${s
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-]/g, '')}`

  // useEffect(() => {
  //   router.events.on('routeChangeStart', handleCloseMenu)

  //   return () => {
  //     router.events.off('routeChangeStart', handleCloseMenu)
  //   }
  // }, [router])

  return (
    <SectionThemeProvider colorScheme="header">
      <S.HeaderWrapper id="main-header" scrollDirection={scrollDirection}>
        {/* Pre Header */}
        <Visible breakpoints={['xl', 'xxl', 'xxxl']}>
          <S.PreHeader>
            {allSiteLink ? (
              <S.PreHeaderMenuLeftSide>
                <Button
                  {...allSiteLink.cta}
                  iconStart={'four-square'}
                  variant="quaternary"
                  noHorizontalPadding
                />
              </S.PreHeaderMenuLeftSide>
            ) : null}
            {serviceMenu && serviceMenu.length > 0 ? (
              <S.PreHeaderMenu>
                {serviceMenu.map(({ cta, iconStart, isAllSiteLink }, idx) => {
                  if (isAllSiteLink) return null
                  return (
                    <Button
                      {...cta}
                      iconStart={iconStart}
                      key={`header-menu-item-${idx}`}
                      variant="quaternary"
                      noHorizontalPadding
                    />
                  )
                })}
                <LanguageSwitch pageLocalizations={pageLocalizations} />
              </S.PreHeaderMenu>
            ) : null}
          </S.PreHeader>
        </Visible>
        <S.Header id="main-header-content">
          <S.HeaderLeft>
            {/* Menu Button and Search - Mobile */}
            <Visible breakpoints={['xs', 'sm', 'md', 'lg']}>
              {headerMenu && headerMenu.length > 0 ? (
                <Button
                  ariaLabel={isOpenMenu ? t('closeNavigationMenu') : t('openNavigationMenu')}
                  iconEnd={isOpenMenu ? 'x-mark' : 'bars-3'}
                  iconEndSize="big"
                  variant="secondary"
                  aria-expanded={isOpenMenu}
                  handleClick={handleToggleMenu}
                />
              ) : null}
              {/** TODO: siti del gruppo */}
              {headerMenu && headerMenu.length > 0 ? (
                <MenuMobile
                  data={menu}
                  isOpen={isOpenMenu}
                  headerMenu={headerMenu}
                  serviceMenu={serviceMenu}
                  submenu={submenu}
                  setSubmenu={setSubmenu}
                  handleOpenMenu={handleOpenMenu}
                  handleCloseMenu={handleCloseMenu}
                  isSubmenuOpen={isSubmenuOpen}
                  setIsSubmenuOpen={setIsSubmenuOpen}
                />
              ) : null}
            </Visible>
            {/* Logo, Menu Button and Search - Desktop */}
            <Visible breakpoints={['xl', 'xxl', 'xxxl']}>
              <S.HeaderLogo as={Link} href="/">
                <Icon name={'brand-logo'} useIconColor unlockedProportions />
              </S.HeaderLogo>
            </Visible>
          </S.HeaderLeft>
          {/* Logo - Mobile */}
          <Visible breakpoints={['xs', 'sm', 'md', 'lg']}>
            <S.HeaderLogo as={Link} href="/">
              <Icon name={'brand-logo'} useIconColor unlockedProportions />
            </S.HeaderLogo>
            <LanguageSwitch pageLocalizations={pageLocalizations} />
          </Visible>
          <S.HeaderRight>
            {/* Header Menu - Desktop */}
            {headerMenu && headerMenu.length > 0 ? (
              <Visible breakpoints={['xl', 'xxl', 'xxxl']}>
                <S.HeaderMenu>
                  {headerMenu.map((item, idx) => {
                    if (item.withSubmenu) {
                      const triggerId = `${toId(item.label)}-trigger`
                      const panelId = `${toId(item.label)}-panel`
                      const expanded = item.label === submenu && isOpenMenu

                      return (
                        <Button
                          aria-expanded={item.label === submenu}
                          label={item.label}
                          variant={'secondary'}
                          key={`header-menu-item-${idx}`}
                          isActive={item.label === submenu}
                          iconEnd={'chevron-down'}
                          id={triggerId}
                          aria-haspopup="true"
                          aria-expanded={expanded}
                          aria-controls={panelId}
                          handleClick={() => {
                            handleToggleMenu(item.label)
                          }}
                        />
                      )
                    } else if (item.isPrimary) {
                      return (
                        <Button
                          href={item.href}
                          label={item.label}
                          variant={'primary'}
                          key={`header-menu-item-${idx}`}
                          iconEnd={'arrow-right'}
                        />
                      )
                    } else {
                      return (
                        <Button
                          href={item.href}
                          label={item.label}
                          variant={'secondary'}
                          key={`header-menu-item-${idx}`}
                        />
                      )
                    }
                  })}
                </S.HeaderMenu>
              </Visible>
            ) : null}
            {/* Header Icons */}
          </S.HeaderRight>
        </S.Header>
        <Visible breakpoints={['xl', 'xxl', 'xxxl']}>
          <Menu
            data={menu}
            isOpen={isOpenMenu}
            openSubmenu={submenu}
            handleCloseMenu={handleCloseMenu}
            panelId={submenu ? `${toId(submenu)}-panel` : undefined}
            labelledById={submenu ? `${toId(submenu)}-trigger` : undefined}
            scopeId="main-header-content"
          />
          <S.MenuOverlay
            isOpen={isOpenMenu}
            onClick={handleCloseMenu}
            scrollDirection={scrollDirection}
          />
        </Visible>
      </S.HeaderWrapper>
    </SectionThemeProvider>
  )
}

export default Header
